var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.00713C1 11.8043 6.51056 17.3148 13.3077 17.3148H15.1538C15.6435 17.3148 16.1131 17.1203 16.4593 16.7741C16.8055 16.4279 17 15.9583 17 15.4687V14.3429C17 13.9195 16.712 13.5503 16.3009 13.4477L12.6718 12.5403C12.3108 12.45 11.9317 12.5854 11.7093 12.8824L10.9134 13.9433C10.6821 14.2518 10.2825 14.3881 9.92062 14.2551C8.57734 13.7613 7.35746 12.9814 6.34546 11.9694C5.33347 10.9574 4.55354 9.73748 4.05969 8.3942C3.92677 8.03236 4.06297 7.63277 4.37149 7.40138L5.43241 6.60549C5.73026 6.38313 5.86482 6.00323 5.77456 5.64302L4.86708 2.0139C4.81714 1.81426 4.70192 1.63704 4.53974 1.51038C4.37755 1.38372 4.17768 1.31489 3.9719 1.31482H2.84615C2.35652 1.31482 1.88695 1.50932 1.54073 1.85555C1.1945 2.20177 1 2.67134 1 3.16097V5.00713Z",
    stroke: "#00848D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.03369a8a0ef95bcb6f5125436f8387e8.svg";
export { ForwardRef as ReactComponent };